import { Footer } from "../Footer";
import { Header } from "../Header";
import { LayoutWrapper, LayoutMain } from "./Layout.style";

export const Layout = ({ children }) => {
  return (
    <LayoutWrapper>
      <Header />
      <LayoutMain>{children}</LayoutMain>
      <Footer />
    </LayoutWrapper>
  );
};
